import { useEffect, useState } from "react";
import { Hash } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const pad = (n) => String(Math.max(1, parseInt(n) || 1)).padStart(7, "0");

export const NumberingSettings = () => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/settings/numbering").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = (key, patch) => setItems(items.map((it) => it.key === key ? { ...it, ...patch } : it));
  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(items.map((it) => [it.key, { prefix: it.prefix, next: parseInt(it.next) || 1 }]));
      const { data } = await api.put("/settings/numbering", body); setItems(data); toast.success("Numérotation enregistrée");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <section className="rise space-y-3 rounded-lg border bg-card p-6" data-testid="settings-numbering">
      <div className="flex items-center justify-between"><h3 className="font-display text-lg font-semibold">Numérotation des documents</h3><Button size="sm" variant="secondary" onClick={save} disabled={busy} data-testid="numbering-save"><Hash size={14} /> Enregistrer</Button></div>
      <div className="space-y-2">
        {items.map((it) => (
          <div key={it.key} className="grid items-center gap-2 sm:grid-cols-[1fr_90px_120px_130px]" data-testid={`numbering-row-${it.key}`}>
            <span className="text-sm">{it.label}</span>
            <Input value={it.prefix} maxLength={5} onChange={(e) => set(it.key, { prefix: e.target.value.toUpperCase() })} className="font-mono uppercase" data-testid={`numbering-prefix-${it.key}`} />
            <Input type="number" min={1} value={it.next} onChange={(e) => set(it.key, { next: e.target.value })} className="font-mono" data-testid={`numbering-next-${it.key}`} />
            <span className="font-mono text-xs text-muted-foreground" data-testid={`numbering-preview-${it.key}`}>→ {it.prefix}{pad(it.next)}</span>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">Préfixe : 1 à 5 lettres/chiffres. Le « prochain numéro » s'applique au prochain document créé — attention aux doublons si vous reculez la séquence.</p>
    </section>
  );
};
